import { SwapSeatUnavailableReason } from '../../../../../utils/swap-seats-utils';
export const shouldShowSwapSeatsButton = (seatSwapAvailabilityStatus) => {
    if (seatSwapAvailabilityStatus.isAvailable)
        return true;
    switch (seatSwapAvailabilityStatus.unavailableReason) {
        case SwapSeatUnavailableReason.OrderIncludesInSeatDeliveryItems:
        case SwapSeatUnavailableReason.OrderIncludesPackageTickets:
        case SwapSeatUnavailableReason.ShowtimeEnded:
        case SwapSeatUnavailableReason.ShowtimeSoldOut:
            return true;
        default:
            return false;
    }
};
